import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OriginalFare } from 'src/app/core/models/cancellation.model';
import { CommissionRefund } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-edit-comission',
  templateUrl: './edit-comission.component.html',
  styleUrls: ['./edit-comission.component.scss'],
})
export class EditComissionComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() commissions: CommissionRefund[];
  @Input() originalFare: OriginalFare;
  @Output() sendCommissions = new EventEmitter<CommissionRefund[]>();

  selectedButton: string = null;
  value: number = 0;

  ngOnInit(){
    this.commissions.forEach( item => item.commissionType = "percentage");
  }

  sendValues() {
    this.sendCommissions.emit(this.commissions);
  }
}
